export default (theme) => {
  return {
    formContainer: {
      borderRadius: '1rem',
      backgroundColor: theme.palette.common.secondary,
    },
  }
}
